module.exports = __webpack_public_path__ + "static/media/info-circle.a2066d95.svg";